<template>
    <div class="auth-modal">
        <public-modal-view
            :without-close="!!visible"
            :flat="flat"
            :loading="loading"
            @close="hideModal"
            v-show="isModalVisible"
        >
            <InformProductPrerecording
                v-if="currentFlow.key === 'PRODUCT_PRERECORDING' && isModalVisible"
                @set="currentFlow = $event"
                @loading="loading = $event"
                :key="currentFlow.key"
                :previous="currentFlow.previous"
                :data="currentFlow.data"
            />
        </public-modal-view>
    </div>
</template>

<script>
import PublicModalView from "../components/PublicModalView"
import { PRERECORDING_KEY } from "../shared/keys/prerecording-key"
import PublicModalMixin from "../shared/mixins/public-modal-mixin"

import { EventBus } from "~events"
import { FLOW_TYPES } from "../components/flow/data/flow-types"
import { FLOW_VIEWS } from "../components/flow/data/flow-views"

import InformProductPrerecording from "../components/inform/InformProductPrerecording"

/**
 * @description The components of the modal window are dynamically substituted depending on the passed key
 * @see matching type-view {@link FLOW_TYPES} and {@link FLOW_VIEWS}
 */

export default {
    props: {
        config: {
            type: Object,
            default: () => ({
                key: "",
                data: {}
            })
        }
    },
    name: "DefaultAuthModal",
    mixins: [PublicModalMixin],
    components: {
        InformProductPrerecording,
        PublicModalView
    },
    data() {
        return {
            currentFlow: null,
            subscriptions: null,
            loading: false
        }
    },
    created() {
        if (!this.config.key) {
            this.currentFlow = FLOW_TYPES.PRODUCT_PRERECORDING
        } else {
            this.currentFlow = this.config
        }

        if (this.visible) {
            this.isModalVisible = true
        }

        EventBus.$on(`${PRERECORDING_KEY}_OPEN`, () => {
            this.openModal()
        }),
            (this.subscriptions = [
                EventBus.$on(`${PRERECORDING_KEY}_OPEN`, () => {
                    this.openModal()
                }),
                EventBus.$on(`${PRERECORDING_KEY}_HIDE`, () => {
                    this.hideModal()
                })
            ])
    },
    methods: {
        getFlowView() {
            return FLOW_VIEWS[this.currentFlow.key]
        }
    },
    destroyed() {
        if (this.subscriptions) {
            for (const unsubscribe of this.subscriptions) {
                unsubscribe()
            }
        }
    }
}
</script>
